module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAVdJREFUOE91kjEoxVEUxn+nDAaDwWA0GAhlYDCKgVAGi0E9WZXEYjQbMFkUJRkYFC9vYMJGDIpC3mgwGAwGddzvubdu/55Tt+6953znnO87x8jM3RuAKWAE6AJ+gFfgCKiY2XcKt3Rx9+4QfAh05Mmy+31IMmNmD/qrAd29F7gEmv4Bpe8vYNDMbszdG4FHoC16R4FhYCm+3xUMnMWYJ6BHwBKwk1WqANPAG9AMLAICH2QxswKeAmOFFlWhD5gDBoC7rCOFlgV8BtoLQLXTH8Hiv17wv9QDrgLHwEc8SeVcvKqA50HRoSxjFfgE9kNF0UjcNC7NWXYh4DKwlgG3gWtA7epMRt8WoAnIVgSUcuLZUuCxGQTZjcLkLincmRZAK3aStaLAK+AWWMhQWsEJM6vkKzcO7MXZ1Vsg8dbKifffyiVz99ag5Hycq9RUBfEsh4QbZiZwzX4BVkBpDUqxIkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_payment.png
// module id = 8BHn
// module chunks = 1